import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from '../common/common-crud.service';
import {ScheduleProfile} from '../../model/tools/schedule-profile';
import {CrystalclearToolsBackUrl} from '../config/crystalclear-tools-back-url';
import {Observable} from 'rxjs';
import {ApiValidation} from '../../model/api/api-validation';
import {ScheduleProperties} from '../../model/tools/schedule-properties';

@Injectable({
  providedIn: 'root'
})
export class SchedulerService extends CommonCrudService<ScheduleProfile> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearToolsBackUrl.GET_SCHEDULER_PROFILE_LIST,
      CrystalclearToolsBackUrl.SAVE_SCHEDULER_PROFILE,
      CrystalclearToolsBackUrl.DELETE_SCHEDULER_PROFILE);
  }

  public execute(titles: string[]): Observable<ApiValidation<any>> {
    return this.post(CrystalclearToolsBackUrl.EXECUTE_SCHEDULER_PROFILE, titles);
  }

  public refresh(): Observable<ApiValidation<any>> {
    return this.post(CrystalclearToolsBackUrl.REFRESH_SCHEDULER_PROFILE);
  }

  public loadSettings(): Observable<ApiValidation<any>> {
    return this.post(CrystalclearToolsBackUrl.LOADSETTINGS_SCHEDULER_PROFILE);
  }

  public saveSettings(settings: ScheduleProperties): Observable<ApiValidation<any>> {
    return this.post(CrystalclearToolsBackUrl.SAVESETTINGS_SCHEDULER_PROFILE, settings);
  }

}
